import React from 'react';
import PropTypes from 'prop-types';
import AddCoworkersEmailInput from './AddCoworkersEmailInput';
import RoleChangeDropdown from '../../AddCoworkersModal/RoleChangeDropdown';
import './AddCoworkersInput.scss';

class AddCoworkersInput extends React.Component {
  renderErrors() {
    const { errors } = this.props;

    return (
      <div>
        {errors.map((errorMessage, index) => (
          <div
            className="mt-3 error-messages"
            key={`${errorMessage[0]}${index}`}
          >
            <i className="me-3 fas fa-exclamation-triangle" />
            {errorMessage}
          </div>
        ))}
      </div>
    );
  }

  renderEmailRoleInput() {
    const {
      emails,
      onChangeEmails,
      invitableRoles,
      selectedRole,
      onChangeSelectedRole,
    } = this.props;

    return (
      <table className="email-role-input-table" width="100%">
        <tbody>
          <tr>
            <th className="body-text-2 medium-weight pb-3" width="64%">Emails</th>
            <th className="body-text-2 medium-weight pb-3" width="36%">Role</th>
          </tr>
          <tr className="email-tags-and-roles-dropdown">
            <td>
              <AddCoworkersEmailInput
                emails={emails}
                handleChange={(newEmails) => onChangeEmails(newEmails)}
              />
            </td>
            <td>
              <div className="roles-dropdown">
                <RoleChangeDropdown
                  permissionOptions={invitableRoles}
                  onChange={(newRole) => onChangeSelectedRole(newRole)}
                  value={selectedRole}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderMessageInput() {
    const { message, placeholder, onChangeMessage } = this.props;

    return (
      <div className="mb-3 mt-3">
        <div className="invitation-label mb-3">
          Message
          {' '}
          <span className="normal-weight">(Optional)</span>
        </div>
        <textarea
          className="invitation-message-textarea"
          rows="3"
          placeholder={placeholder}
          value={message}
          onChange={(event) => onChangeMessage(event.target.value)}
        />
      </div>
    );
  }

  render() {
    const { withMessage, errors } = this.props;

    const hasErrors = errors && errors.length > 0;

    return (
      <div className="add-coworkers-input-container style-guide">
        {this.renderEmailRoleInput()}
        {hasErrors && this.renderErrors()}
        {withMessage && this.renderMessageInput()}
      </div>
    );
  }
}

AddCoworkersInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeEmails: PropTypes.func.isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedRole: PropTypes.string.isRequired,
  onChangeSelectedRole: PropTypes.func.isRequired,
  withMessage: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  message: PropTypes.string,
  placeholder: PropTypes.string,
  onChangeMessage: PropTypes.func,
};

AddCoworkersInput.defaultProps = {
  withMessage: true,
  errors: [],
  message: '',
  placeholder: 'Write a message here...',
  onChangeMessage: () => null,
};

export default AddCoworkersInput;
